import { Modal } from '@simplywallst/ui-core';
import { Heading, Button } from '@simplywallst/ui-core/next';

import CrossSolid from '@simplywallst/ui-core/icons/CrossSolid';
import DividendOutline from '@simplywallst/ui-core/icons/DividendOutline';
import ChartUpOutline from '@simplywallst/ui-core/icons/ChartUpOutline';
import StockSplitOutline from '@simplywallst/ui-core/icons/StockSplitOutline';

interface Props {
  onClose: () => void;
}

export const BetaModal = ({ onClose }: Props) => {
  return (
    <Modal isNaked fullscreen onClose={onClose}>
      <div
        className="grid grid-cols-[auto] content-center md:grid-cols-[700px]"
        data-theme="light"
      >
        <div className="rounded-md bg-legacy-white p-x2 sm:p-x3">
          <div className="grid gap-6">
            <div className="grid grid-cols-[auto_40px] grid-rows-[minmax(40px,max-content)] items-center justify-between">
              <Heading as="h2" size="xLarge" className="text-nowrap">
                💡 Key tips for your transactions
              </Heading>
              <Button
                type="button"
                variant="subtle"
                onClick={onClose}
                aria-label="Close"
                className="p-0"
              >
                <CrossSolid className="fill-legacy-spacegray" />
              </Button>
            </div>

            <div className="grid grid-cols-[auto] gap-6 md:grid-cols-3">
              <div className="grid grid-rows-[24px_auto_auto] gap-2 rounded-md bg-surface-3 p-x1_5 md:grid-rows-[24px_46px_auto]">
                <DividendOutline className="w-x3 fill-soft" />
                <Heading as="h3" size="xSmall" weight="strong">
                  Dividends Handled Automatically
                </Heading>
                <p className="text-xs text-soft">
                  No need to add dividends or corporate events. They're
                  automatically accounted for.
                </p>
              </div>
              <div className="grid grid-rows-[24px_auto_auto] gap-2 rounded-md bg-surface-3 p-x1_5 md:grid-rows-[24px_46px_auto]">
                <StockSplitOutline className="w-x3 fill-soft" />
                <Heading as="h3" size="xSmall" weight="strong">
                  Stock Splits? We've Got You Covered
                </Heading>
                <p className="text-xs text-soft">
                  Enter your transactions with the original stock price and
                  units. Stock splits will be adjusted automatically.
                </p>
              </div>
              <div className="grid grid-rows-[24px_auto_auto] gap-2 rounded-md bg-surface-3 p-x1_5 md:grid-rows-[24px_46px_auto]">
                <ChartUpOutline className="w-x3 fill-soft" />
                <Heading as="h3" size="xSmall" weight="strong">
                  Double-check stock tickers and exchanges
                </Heading>
                <p className="text-xs text-soft">
                  Ensure each holding is matched with the correct ticker and
                  exchange for accurate tracking.
                </p>
              </div>
            </div>

            <div className="grid grid-cols-[max-content_max-content] justify-end gap-4">
              <Button
                variant="outline"
                href="https://support.simplywall.st/hc/en-us/articles/10974593931151-How-to-Bulk-Add-Transactions-to-Create-Your-Stock-Portfolio"
              >
                Read full documentation
              </Button>
              <Button type="button" variant="primary" onClick={onClose}>
                Continue
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
